
<div>
  <product-category-assignment v-for="category_assignment in category_assignments" :key="category_assignment.id"
                               :category-assignment="category_assignment"
                             :is-public="isPublic" >
  </product-category-assignment>
  <b-container v-if="subcategories.length > 0">
    <b-row >
      <b-col>
        <small>Didn't find what you are looking for? <b-button variant="link" size="sm" v-on:click="selectCategory(subcategories[0].id)">Click to Configure</b-button>
        </small>
      </b-col>
    </b-row>
  </b-container>
</div>
